<template>
  <ReferalPromo />
  <ReferalFlow />
  <ReferalBenefits />
  <ReferalFaq />
</template>

<script setup lang="ts">
import { eventTracker, AnalyticsEventKey } from '~/utils/analyticServices';

const { t } = useI18n();

useHead({
  title: t('meta.referral.title'),
});

onMounted(() => {
  eventTracker(AnalyticsEventKey.RefferalPageViewed, {
    platform: 'WebSite',
  });
});
</script>